import { Component, OnInit, Input } from '@angular/core';
import { TableComponent } from "app/components/common/table/table.component";
import {TableStatic} from "../table-static";



@Component({
    selector: 'app-table-static',
    templateUrl: './table-static.component.html',
    styleUrls: ['./table-static.component.css']
})
export class TableStaticComponent implements OnInit, TableStatic {

    @Input()
    public label: string;

    @Input()
    public value: string;

    constructor(private tableComponent: TableComponent) {

    }

    ngOnInit() {
        this.tableComponent.addStatics(this);
    }
}
